import Pusher from "pusher-js"

let pusherInstance

export const initPusher = () => {
  pusherInstance = new Pusher("10221858a0694b3057a7", {
    cluster: "mt1",
    forceTLS: true
  })
}

export const subscribeChannel = () => {
  return pusherInstance.subscribe("pamplemousse_production")
}
